export default class CancellationActions {
  static FEEDBACK = "feedback";

  static RETAIN = "retain";

  static CANCEL = "cancel";

  static RESUME = "resume";
}
